'use strict';

const isTimeDurationNegative = (timeDuration) => {
  return timeDuration.days !== void 0 && timeDuration.days < 0 || timeDuration.hours !== void 0 && timeDuration.hours < 0 || timeDuration.minutes !== void 0 && timeDuration.minutes < 0 || timeDuration.seconds !== void 0 && timeDuration.seconds < 0 || timeDuration.milliseconds !== void 0 && timeDuration.milliseconds < 0;
};

module.exports = isTimeDurationNegative;
//# sourceMappingURL=isTimeDurationNegative.cjs.map
